export const roleConsts = {
    GET_ROLES: "GET_ROLES",
    GET_ROLE: "GET_ROLE",
    UPDATE_ROLE: "UPDATE_ROLE",
    DELETE_ROLE: "DELETE_ROLE",
    CLEAR_ROLE_DATA: "CLEAR_ROLE_DATA",
};